import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentMethodCcGenericDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 32,
	viewBox: "0 0 48 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4420_440)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 48,
				height: 32,
				rx: 4,
				fill: "url(#paint0_linear_4420_440)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: .25,
				y: .25,
				width: 47.5,
				height: 31.5,
				rx: 3.75,
				stroke: "white",
				strokeOpacity: .16,
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 4,
				y: 8,
				width: 3,
				height: 2,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 10,
				y: 8,
				width: 3,
				height: 2,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 7.5,
				y: 8,
				width: 2,
				height: 7,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 4,
				y: 10.5,
				width: 3,
				height: 2,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 10,
				y: 10.5,
				width: 3,
				height: 2,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 4,
				y: 13,
				width: 3,
				height: 2,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 10,
				y: 13,
				width: 3,
				height: 2,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 4,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 6,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 8,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 10,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 14,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 16,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 18,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 20,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 24,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 26,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 28,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 30,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 34,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 36,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 38,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 40,
				y: 21,
				width: 1,
				height: 3,
				rx: .5,
				fill: "white",
				fillOpacity: .48
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_4420_440",
		x1: 0,
		y1: 0,
		x2: 48,
		y2: 32,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", {
			stopColor: "white",
			stopOpacity: .04
		}), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "white",
			stopOpacity: .16
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4420_440",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 32,
			fill: "white"
		})
	})] })]
});
export default SvgPaymentMethodCcGenericDark;
